<template>
    <section class="search__results">
        <div class="search__results-container">
            <form method="get" action="/">
                <label for="search" class="access-hidden">Search</label>
                <input
                    id="search"
                    class="header__modal-search-input"
                    type="search" placeholder="Search"
                    name="search"
                    :value="query"
                    autofocus
                    required
                >
            </form>
            <div class="search__results-signifier">Search Results:</div>
            <article
                v-for="result in results"
                class="search__result"
            >
                <a
                    class="search__result-title"
                    v-text="decode(result.title.rendered)"
                    :href="result.link"
                />
                <div
                    class="search__result-content"
                    v-html="spliceContent(result.content.rendered)"
                />
                <a
                    class="search__result-link"
                    :href="result.link"
                    v-text="'Read More'"
                />
                <hr class="search-result__hr">
            </article>
            <button
                v-if="postsRemaining"
                @click="getPosts"
                v-text="'Load More'"
                class="search-results__load-more"
            />
            <div
                v-if="searchResults"
                v-text="'No search results.'"
                class="search__result-none"
            />
        </div>
    </section>
</template>

<script>
import he from 'he';
import axios from 'axios';

export default {
    name: 'SearchResults',
    props: {
        query: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            results: [],
            page: 1,
            removeSearch: false,
            postsRemaining: false,
            searchResults: false,
        };
    },
    methods: {
        decode(string) {
            return he.decode(string);
        },
        spliceContent(searchContent) {
            const spliced = searchContent;
            return spliced
                    .split(' ')
                    .splice(0, 20)
                    .join(' ')
                    .concat('...');
        },
        disableSearchIcon(state) {
            return document.documentElement.classList[state]('search--disabled');
        },
        getPosts() {
            axios
                .get(`/wp-json/wp/v2/search/${this.query}`, {
                    params: {
                        page: this.page,
                        per_page: 5,
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        this.disableSearchIcon('add');
                        this.results = this.results.concat(response.data);
                    } else {
                        this.disableSearchIcon('remove');
                        this.results = [0];
                    }

                    if (response.data.length > 5) {
                        this.postsRemaining = true;
                    } else {
                        this.postsRemaining = false;
                    }

                    if (this.query === '' && this.query === undefined) {
                        this.results = [0];
                    }
                });

            this.page += 1;
        },
    },
    watch: {
        results() {
            if (this.results.length === 0) {
                this.searchResults = true;
            } else {
                this.searchResults = false;
            }
        },
    },
    created() {
        this.getPosts();
    },
};
</script>



// WEBPACK FOOTER //
// SearchResults.vue?532509cd